<template>
  <textarea :class="style({ isError })" :rows="rows" :value="modelValue" v-bind="$attrs" @input="updateValue" />
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';

interface Props {
  modelValue?: string;
  isError?: boolean;
  customClass?: string;
  rows?: number;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
  isError: false,
  customClass: 'h-auto',
  rows: 3,
});

interface Emits {
  (event: 'update:modelValue', value: string): void;
}

const emits = defineEmits<Emits>();

const updateValue = (e: Event) => {
  emits('update:modelValue', (e.target as HTMLInputElement).value);
};

/**
 * Style
 */
const style = tv({
  base: `box-border  w-full appearance-none rounded-none border border-solid border-light-bd-muted bg-white px-4 py-2 text-sm text-black1 outline-none transition-all duration-100 ease-in-out placeholder:text-gray2 ${props.customClass}`,
  variants: {
    isError: {
      true: 'border-red1 bg-red2 text-red1',
    },
  },
});
</script>
